
import * as angular from "angular";

export class ValidatePasswordDirective implements angular.IDirective {

    restrict = "A";
    require = "ngModel";

    link: (scope: angular.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel) => void;

    constructor() {

        ValidatePasswordDirective.prototype.link = ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attrs: ng.IAttributes, ngModel: angular.INgModelController) => {
            ngModel.$validators["validatePasswordLength"] = (modelValue: string) => {
                if (!modelValue) return true;

                return modelValue.length >= 8;
            };

            ngModel.$validators["validatePasswordLowercase"] = (modelValue: string) => {
                if (!modelValue) return true;

                return modelValue.toUpperCase() !== modelValue;
            };

            ngModel.$validators["validatePasswordUppercase"] = (modelValue: string) => {
                if (!modelValue) return true;

                return modelValue.toLowerCase() !== modelValue;
            };

            ngModel.$validators["validatePasswordNumber"] = (modelValue: string) => {
                if (!modelValue) return true;

                return modelValue.match(/\d+/g) != null;
            };

            ngModel.$validators["validatePasswordSpecial"] = (modelValue: string) => {
                if (!modelValue) return true;

                return modelValue.replace(/[0-9a-zA-Z]/gi, "").length > 0;
            };
        }
    }

    static factory(): angular.IDirectiveFactory {
        const directive = () => new ValidatePasswordDirective();

        directive.$inject = [];

        return directive;
    }
}
